<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs1" label="tab1">线下合同</vxe-radio>
          </li>
          <li>
            <vxe-radio name="xtabs2" label="tab2">自定义合同</vxe-radio>
          </li>
          <li>
            <vxe-radio name="xtabs3" label="tab3">运输合同</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div
          v-show="selectTab === 'tab1'"
          class="search-box search-filter"
          style="display: flex; align-items: center"
      >
        <vxe-input
            style="height: 34px !important"
            v-model="title"
            type="search"
            placeholder="请搜索合同名称"
            @keyup.enter.native="search"
            @search-click="search"
        ></vxe-input>
        <Select
            style="width: 180px; margin-left: 10px"
            v-model="companyName"
            filterable
            prefix="ios-arrow-down"
            :remote-method="
            (file) =>
              remoteMethod2(file, 'compNameOptions', 'agreementTwo', 'contractListCompanyName')
          "
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'compNameOptions')"
            @on-change="onChange(1, $event)"
            @on-query-change="onQueryChange(1, $event)"
            placeholder="输入平台企业"
        >
          <Option v-for="option in compNameOptions" :value="option.paramId" :key="option.paramValue"
          >{{ option.paramValue }}
          </Option>
        </Select>
        <vxe-input
            style="height: 34px !important; margin-left: 10px"
            v-model="clientName"
            type="search"
            placeholder="请搜索签约方"
            @keyup.enter.native="search"
            @search-click="search"
        ></vxe-input>
        <vxe-input
            style="height: 34px !important; margin-left: 10px"
            v-model="createUser"
            type="search"
            placeholder="请搜索创建人"
            @keyup.enter.native="search"
            @search-click="search"
        ></vxe-input>
      </div>
      <div
          v-show="selectTab === 'tab2'"
          class="search-box search-filter search-filter-agreement"
          style="display: flex; align-items: center"
      >
        <vxe-input
            style="width: 150px; height: 34px !important"
            v-model="searchContractName"
            type="search"
            placeholder="请搜索合同名称"
            @keyup.enter.native="search2"
            @search-click="search2"
        ></vxe-input>
        <Select
            style="width: 180px; height: 34px; overflow: hidden; margin-left: 10px"
            v-model="searchSecondPartyName"
            multiple
            filterable
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'secondPartyNameOptions')"
            :remote-method="(file) =>remoteMethod(file,'secondPartyNameOptions', 'eleContract', 'queryPartyName', 2)"
            placeholder="输入签约方"
            @on-change="onChange(3, $event)"
        >
          <Option v-for="option in secondPartyNameOptions" :value="option.text" :key="option.text"
          >{{ option.text }}
          </Option>
        </Select>
        <vxe-input
            style="width: 150px; height: 34px !important; margin-left: 10px"
            v-model="searchCarShipNum"
            type="search"
            placeholder="请搜索车船号"
            @keyup.enter.native="search2"
            @search-click="search2"
        ></vxe-input>
        <Select
            style="width: 180px; height: 34px; overflow: hidden; margin-left: 10px"
            v-model="searchSalesMan"
            multiple
            filterable
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions')"
            :remote-method="(file) =>remoteMethod(file,'salesManOptions', 'eleContract', 'queryContractFadadaKeyword', 3)"
            placeholder="输入业务员"
            @on-change="onChange(4, $event)"
        >
          <Option v-for="option in salesManOptions" :value="option.id" :key="option.text"
          >{{ option.text }}
          </Option>
        </Select>
        <Select
            style="width: 180px; height: 34px; overflow: hidden; margin-left: 10px"
            v-model="searchCreateUser"
            multiple
            clearable
            filterable
            placement="bottom-end"
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'createUserOptions')"
            :remote-method="(file) =>remoteMethod(file,'createUserOptions', 'eleContract', 'queryContractFadadaKeyword', 4)"
            placeholder="输入创建人"
            @on-change="onChange(5, $event)"
        >
          <Option v-for="option in createUserOptions" :value="option.id" :key="option.text"
          >{{ option.text }}
          </Option>
        </Select>
      </div>
      <div
          v-show="selectTab === 'tab3'"
          class="search-box search-filter search-filter-agreement"
          style="display: flex; align-items: center"
      >
        <vxe-input
            style="width: 150px; height: 34px !important"
            v-model="searchContractName3"
            type="search"
            placeholder="请搜索合同名称"
            @keyup.enter.native="search3"
            @search-click="search3"
        ></vxe-input>
        <Select
            style="width: 180px; height: 34px; overflow: hidden; margin-left: 10px"
            v-model="searchFirstPartyName"
            multiple
            filterable
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'firstPartyNameOptions')"
            placeholder="输入发起方"
            :remote-method="(file) =>remoteMethod(file,'firstPartyNameOptions', 'eleContract', 'queryContractFadadaKeyword', 1)"
            @on-change="onChange3(2, $event)"
        >
          <Option v-for="option in firstPartyNameOptions" :value="option.text" :key="option.text"
          >{{ option.text }}
          </Option>
        </Select>
        <Select
            style="width: 180px; height: 34px; overflow: hidden; margin-left: 10px"
            v-model="searchSecondPartyName3"
            multiple
            filterable
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'secondPartyNameOptions3')"
            :remote-method="(file) =>remoteMethod(file,'secondPartyNameOptions3', 'eleContract', 'queryContractFadadaKeyword', 2)"
            placeholder="输入签约方"
            @on-change="onChange3(3, $event)"
        >
          <Option v-for="option in secondPartyNameOptions3" :value="option.text" :key="option.text"
          >{{ option.text }}
          </Option>
        </Select>
        <vxe-input
            style="width: 150px; height: 34px !important; margin-left: 10px"
            v-model="searchCarShipNum3"
            type="search"
            placeholder="请搜索车船号"
            @keyup.enter.native="search3"
            @search-click="search3"
        ></vxe-input>
        <Select
            style="width: 180px; height: 34px; overflow: hidden; margin-left: 10px"
            v-model="searchSalesMan3"
            multiple
            filterable
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions3')"
            :remote-method="(file) =>remoteMethod(file,'salesManOptions3', 'eleContract', 'queryContractFadadaKeyword', 3)"
            placeholder="输入业务员"
            @on-change="onChange3(4, $event)"
        >
          <Option v-for="option in salesManOptions3" :value="option.id" :key="option.text"
          >{{ option.text }}
          </Option>
        </Select>
        <Select
            style="width: 180px; height: 34px; overflow: hidden; margin-left: 10px"
            v-model="searchCreateUser3"
            multiple
            clearable
            filterable
            placement="bottom-end"
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'createUserOptions3')"
            :remote-method="(file) =>remoteMethod(file,'createUserOptions3', 'eleContract', 'queryContractFadadaKeyword', 4)"
            placeholder="输入创建人"
            @on-change="onChange3(5, $event)"
        >
          <Option v-for="option in createUserOptions3" :value="option.id" :key="option.text"
          >{{ option.text }}
          </Option>
        </Select>
      </div>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
          :loading="loading"
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable1"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="tableData"
          @current-change="currentChangeEvent"
      >
        <vxe-table-column field="id" title="序号" width="90"></vxe-table-column>
        <vxe-table-column field="numb" title="合同编号" width="200"></vxe-table-column>
        <vxe-table-column field="title" title="合同名称" width="200"></vxe-table-column>
        <vxe-table-column field="companyName" title="平台企业" width="240"></vxe-table-column>
        <vxe-table-column field="clientName" title="签约方" width="240"></vxe-table-column>
        <vxe-table-column field="addTime" title="签约日期">
          <template slot-scope="{ row }">
            <span>{{ row.addTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createUser" title="创建人"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab2'">
      <vxe-table
          :loading="loading"
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable2"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="tableData2"
          @current-change="currentChangeEvent2"
      >
        <vxe-table-column field="id" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="contractNum" title="合同编号" width="140"></vxe-table-column>
        <vxe-table-column field="contractName" title="合同名称" width="120"></vxe-table-column>
        <vxe-table-column field="contractType" title="合同类型" width="120">
          <template slot-scope="{ row }">
            <span>{{ elecontractType(row) }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="signType" title="签约方式" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.signType | signType }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="partyNameStr" title="签约方" width="400" show-overflow="ellipsis">
          <template slot-scope="{ row }">
            <Poptip trigger="hover" placement="left" transfer>
              <span>{{ row.partyNameStr }}</span>
              <template slot="title"></template>
              <template slot="content">
                <div style="padding: 18px 0;box-sizing: border-box;">
                  <div v-for="(item,index) in row.ordContractFadadaExpands" :key="index" style="">
                    <div class="signDiv">
                      <div :class="item.state === 2 || item.state === 4 ? 'signState grey' : 'signState'">
                        {{ item.state === 2 ? '已签' : item.state === 4 ? '已拒绝' : '待签' }}
                      </div>
                      <div class="signContent">
                        <span>{{ item.partyName }}</span>
                        <span>{{ item.partyPhone ? '手机：' + item.partyPhone : '' }}</span>
                      </div>
                    </div>
                    <div class="line" v-if="(index + 1) !== row.ordContractFadadaExpands.length"></div>
                  </div>
                </div>
              </template>
            </Poptip>
          </template>
        </vxe-table-column>
        <vxe-table-column field="partyTime" title="签约日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.effectiveTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="100"></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="100"></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="100"></vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="100"></vxe-table-column>
        <vxe-table-column field="salesMan" title="业务员" width="100"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page2.currentPage"
          :page-size.sync="page2.pageSize"
          :total="page2.totalResult"
          @page-change="changePage2"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab3'">
      <vxe-table
          :loading="loading"
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable2"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="tableData3"
          @current-change="currentChangeEvent3"
      >
        <vxe-table-column field="id" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="contractNum" title="合同编号" width="140"></vxe-table-column>
        <vxe-table-column field="contractName" title="合同名称" width="120"></vxe-table-column>
        <vxe-table-column field="dataType" title="合同模板" width="100">
          <template slot-scope="{ row }">
            <span>{{ elecontractType(row) }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="firstPartyName" title="发起方" width="240"></vxe-table-column>
        <vxe-table-column field="secondPartyName" title="签约方" width="240"></vxe-table-column>
        <vxe-table-column field="secondPartyTime" title="签约日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.secondPartyTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="100"></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="100"></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="100"></vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="100"></vxe-table-column>
        <vxe-table-column field="salesMan" title="业务员" width="100"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page3.currentPage"
          :page-size.sync="page3.pageSize"
          :total="page3.totalResult"
          @page-change="changePage3"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {isEmpty} from "@/utils/util";

export default {
  name: "ChooseAgreement",
  props: {
    isSalesMan: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      selectTab: "tab1",
      tableData: [],
      tableData2: [],
      tableData3: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      page2: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      page3: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      title: null,
      clientName: null,
      createUser: null,
      companyName: null,
      searchLoading: false,
      compNameOptions: [],
      searchContractName: null,
      searchGoodsName: null,
      searchCarShipNum: null,
      searchFirstPartyName: [],
      firstPartyNameOptions: [],
      searchSecondPartyName: [],
      secondPartyNameOptions: [],
      searchSalesMan: [],
      salesManOptions: [],
      searchCreateUser: [],
      createUserOptions: [],
      searchContractName3: null,
      searchCarShipNum3: null,
      searchSecondPartyName3: [],
      secondPartyNameOptions3: [],
      searchSalesMan3: [],
      salesManOptions3: [],
      searchCreateUser3: [],
      createUserOptions3: [],
      contractListType: [],
      valueType: [],
    };
  },
  created() {

  },
  filters: {
    signType(val) {
      if (val != null) {
        if (val === 1) {
          return "单方签署";
        }
        if (val === 2) {
          return "双方签署";
        }
        if (val === 3) {
          return "多方签署";
        }
      }
    },
  },
  methods: {
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          })
        })
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    getDicData() {
      this.contractListType = [];
      $api.other.getContractType
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              let obj = {
                label: item.dictText,
                value: parseInt(item.encoded)
              };
              this.contractListType.push(obj);
            });
          });
    },
    elecontractType(row) {
      let label = '';
      let val = row.contractType;
      if (row.dataType === 1) {
        this.valueType.map(i => {
          if (val === i.value) {
            label = i.label;
          }
        })
      } else {
        this.contractListType.map(i => {
          if (val === i.value) {
            label = i.label;
          }
        })
      }
      return label;
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    onQueryChange(type, e) {
      if (e === "") {
        switch (type) {
          case 1:
            this.companyName = null;
            this.getList2("", "compNameOptions", "agreementTwo", "contractListCompanyName");
            break;
            // case 2:
            //   this.searchFirstPartyName = [];
            //   this.getList2(
            //     "",
            //     "firstPartyNameOptions",
            //     "eleContract",
            //     "queryContractFadadaKeyword",
            //     1
            //   );
            //   break;
        }
      }
    },
    onChange(type, e) {
      this.page2.currentPage = 1
      switch (type) {
        case 1:
          this.companyName = e;
          this.queryContractList();
          break;
        case 3:
          this.searchSecondPartyName = e;
          this.queryContractList2();
          break;
        case 4:
          this.searchSalesMan = e;
          this.queryContractList2();
          break;
        case 5:
          this.searchCreateUser = e;
          this.queryContractList2();
          break;
      }
    },
    onChange3(type, e) {
      this.page3.currentPage = 1
      switch (type) {
        case 1:
          this.companyName = e;
          this.queryContractList();
          break;
        case 2:
          this.searchFirstPartyName = e;
          this.queryContractList3();
          break;
        case 3:
          this.searchSecondPartyName3 = e;
          this.queryContractList3();
          break;
        case 4:
          this.searchSalesMan3 = e;
          this.queryContractList3();
          break;
        case 5:
          this.searchCreateUser3 = e;
          this.queryContractList3();
          break;
      }
    },
    // onQueryChange1(e) {
    //   if (e === '') {
    //     this.searchFirstPartyName = [];
    //     this.getList('', 'compNameOptions', 'agreementTwo', 'contractListCompanyName');
    //   }
    // },
    // onChange1(e) {
    //   this.searchFirstPartyName = e;
    //   this.queryContractList2();
    // },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
      };

      if (!isEmpty(query)) {
        params.param = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    remoteMethod2(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList2(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList2(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].get(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = [];
        res.data.map(i => {
          if (i) {
            this[options].push(i);
          }
        })
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    changePage(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.queryContractList();
    },
    changePage2(e) {
      this.page2.currentPage = e.currentPage;
      this.page2.pageSize = e.pageSize;
      this.queryContractList2();
    },
    changePage3(e) {
      this.page3.currentPage = e.currentPage;
      this.page3.pageSize = e.pageSize;
      this.queryContractList3();
    },
    currentChangeEvent({row}) {
      this.$emit("choose", row, 1);
    },
    async currentChangeEvent2({row}) {
      // if (!this.isSalesMan) {
      this.$emit("choose", row, 2);
      // } else {
      //   this.$emit("choose", row, 2);
      // }
      // this.$emit("choose", row, true);
    },
    async currentChangeEvent3({row}) {
      this.$emit("choose", row, 3);
    },
    search() {
      // 搜索企业用户列表
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.queryContractList();
    },
    search2() {
      this.page2.currentPage = 1;
      this.page2.pageSize = 10;
      this.queryContractList2();
    },
    search3() {
      this.page3.currentPage = 1;
      this.page3.pageSize = 10;
      this.queryContractList3();
    },
    init() {
      this.selectTab = "tab1";
      this.companyName = null;
      this.title = null;
      this.clientName = null;
      this.createUser = null;
      this.searchFirstPartyName = [];
      this.searchSecondPartyName = [];
      this.searchSalesMan = [];
      this.searchCreateUser = [];
      this.searchCarShipNum = null;
      this.searchContractName = null;
      this.searchContractName3 = null;
      this.searchCarShipNum3 = null;
      this.searchSecondPartyName3 = [];
      this.searchSalesMan3 = [];
      this.searchCreateUser3 = [];
      this.searchSecondPartyName = [];

      this.page.currentPage = 1;
      this.page2.currentPage = 1;
      this.page3.currentPage = 1;
      // this.getList("", "compNameOptions", "agreementTwo", "contractListCompanyName");
      // this.getList2("", "firstPartyNameOptions", "eleContract", "queryContractFadadaKeyword", 1);
      // this.getList2("", "secondPartyNameOptions", "eleContract", "queryContractFadadaKeyword", 2);
      // this.getList2("", "salesManOptions", "eleContract", "queryContractFadadaKeyword", 3);
      // this.getList2("", "createUserOptions", "eleContract", "queryContractFadadaKeyword", 4);

      this.getDictByCode(41400, 'valueType');
      this.getDicData();

      this.queryContractList();
      this.queryContractList2();
      this.queryContractList3();
    },
    async queryContractList() {
      this.loading = true;
      let res = await $api.agreementTwo.post("queryContractListForSalesMan", {
        orderBy: 2,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        companyName: this.companyName,
        title: this.title,
        clientName: this.clientName,
        createUser: this.createUser,
      });
      this.loading = false;
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.tableData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryContractList2() {
      this.loading = true;
      let obj = {
        page: this.page2.currentPage,
        rows: this.page2.pageSize,
        partyNameList: this.searchSecondPartyName.length > 0 ? this.searchSecondPartyName : null,
        salesManIdList: this.searchSalesMan.length > 0 ? this.searchSalesMan : null,
        createUserIdList: this.searchCreateUser.length > 0 ? this.searchCreateUser : null,
        contractName: this.searchContractName ? this.searchContractName : null,
        carShipNum: this.searchCarShipNum ? this.searchCarShipNum : null,
      }
      let res = await $api.eleContract.request("getContractFadadaTwoList", obj);
      if (res.status === 1) {
        this.page2.totalResult = res.data.total;
        this.tableData2 = res.data.rows;
        this.tableData2.map((i) => {
          let partyNameStr = '';
          if (i.ordContractFadadaExpands) {
            i.ordContractFadadaExpands.map(j => {
              partyNameStr = partyNameStr + j.partyName + ','
            });
          }
          i.partyNameStr = partyNameStr.slice(0, partyNameStr.length - 1);
        });
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryContractList3() {
      this.loading = true;
      let res = await $api.eleContract.request("getContractFadadaList", {
        orderBy: 2,
        page: this.page3.currentPage,
        rows: this.page3.pageSize,
        contractName: this.searchContractName3 ? this.searchContractName3 : null,
        carShipNum: this.searchCarShipNum3 ? this.searchCarShipNum3 : null,
        firstPartyNameList: this.searchFirstPartyName.length > 0 ? this.searchFirstPartyName : null,
        secondPartyNameList:
            this.searchSecondPartyName3.length > 0 ? this.searchSecondPartyName3 : null,
        salesManIdList: this.searchSalesMan3.length > 0 ? this.searchSalesMan3 : null,
        createUserIdList: this.searchCreateUser3.length > 0 ? this.searchCreateUser3 : null,
        dataType: 2
      });
      this.loading = false;
      if (res.status === 1) {
        this.page3.totalResult = res.data.total;
        this.tableData3 = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.page = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.$refs.xTable1.clearCurrentRow();
    },
  },
};
</script>

<style lang="css">
.account-search-box {
  position: absolute;
  right: 20px;
  top: 8px;
  height: 36px;
  border: 1px solid #ccc;
  overflow: hidden;
}

.search-filter-agreement .ivu-select-multiple .ivu-tag {
  max-width: 80px;
  overflow: hidden;
}

/*.search-filter-agreement .ivu-select-multiple .ivu-select-input {*/
/*  max-width: 80px;*/
/*  overflow: hidden;*/
/*}*/

.search-filter-agreement .ivu-select-selection {
  overflow: hidden;
  height: 34px;
}

/*.search-filter-agreement .ivu-tag-checked + .ivu-tag-checked {*/
/*  display: none;*/
/*}*/

.signDiv {
  display: flex;
  align-items: flex-start;
}

.signState {
  margin-right: 10px;
  width: 46px;
  height: 20px;
  background: #FFE8E8;
  border-radius: 4px;
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 400;
  color: #FF0000;
  text-align: center;
  line-height: 20px;
}

.grey {
  background: #E8E8E8 !important;
  color: #333333 !important;
}

.line {
  margin: 18px 0;
  width: 100%;
  height: 1px;
  background: #E5E6EB;
}

.signContent {
  display: flex;
  flex-direction: column;
}
</style>

